import type { RootState } from 'store';

export const cartAllInfoSelector = (state: RootState) => state.customer.customerCart;
export const cartInfoSelector = (state: RootState) => state.customer.customerCart.cartInfo;
export const cartItemsSelector = (state: RootState) => state.customer.customerCart.cartItems;
export const cartTotalQuantitySelector = (state: RootState) =>
  state.customer.customerCart.totalQuantity;
export const cartGroupsSelector = (state: RootState) => state.customer.customerCart.groups || [];
export const singleCartInfoSelector = (state: RootState) =>
  state.customer.customerCart.singleCartInfo;
export const singleCartItemsSelector = (state: RootState) =>
  state.customer.customerCart.singleCartItems || [];
export const singleCartGroupsSelector = (state: RootState) =>
  state.customer.customerCart.singleGroups || [];
export const cartOfferChangesSelector = (state: RootState) =>
  state.customer.customerCart.offerChanges || [];
export const cartCouponDiscountSelector = (state: RootState) =>
  state.customer.customerCart.couponDiscountAmount || 0;
export const cartCouponPreviewsSelector = (state: RootState) =>
  state.customer.customerCart.couponPreviews || [];
